import type { ICGTemplateVariation } from '~/modules/campaign-template/types';

import { parseVariantBadge } from '~/presentation/common';
import { GVariantBadge } from '~/presentation/ui';
import { Box } from '@shopify/polaris';

export interface CGTemplateVariantLabelProps {
  variant: ICGTemplateVariation;
}

export const CGTemplateVariantLabel: React.FC<CGTemplateVariantLabelProps> = ({ variant }) => {
  const label = variant.name;
  const badge = parseVariantBadge(variant);

  return (
    <Box maxWidth="100%" width="100%">
      <GVariantBadge
        size="xs"
        {...badge}
        labelProps={{
          variant: 'bodyMd',
          fontWeight: 'medium',
          tone: 'subdued',
        }}
        label={label}
      />
    </Box>
  );
};
